/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type OralExamRunStateResponseEndReason = 'completed' | 'aborted' | 'agent_unavailable' | 'session_void' | null;
